import { action, autorun, makeObservable, observable, reaction } from 'mobx';

import * as model from '../data/model';
import { FabricOptionState } from './FabricOptionState';

export class FabricCuratedSelectionBasedFilterState {
  @observable.shallow
  public curatedSelections: model.FabricCollectionData[] = [];

  @observable.ref
  public selected: model.FabricCollectionData;

  constructor(
    private readonly fabricFeatures: FabricOptionState[],
    curatedSelections: model.FabricCollectionData[],
  ) {
    this.curatedSelections.push(...curatedSelections);

    if (this.curatedSelections.length > 0) {
      this.setSelected(this.curatedSelections[0]);
    }

    makeObservable(this);

    autorun(() => {
      this.fabricFeatures.forEach((feature) => feature.collectionsBasedFilter.update(this.selected));
    });
  }

  @action.bound
  public selectById(id: string) {
    const item = this.curatedSelections.find((x) => x.id === id);

    if (item) {
      this.setSelected(item);
    }
  }

  @action
  private setSelected(selected: model.FabricCollectionData) {
    this.selected = selected;
  }
}
